import { keyframes, style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

const shadowFadeOut = keyframes({
  from: { opacity: 1 },
  to: { opacity: 0 },
});

export const overlayValueAnimation = style({
  position: "relative",
  borderRadius: "0 0 0.3rem 0.3rem",
  selectors: {
    "&::after": {
      position: "absolute",
      inset: 0,
      filter: `drop-shadow(0px 4px 4px ${vars.colors.plBlue})`,
      borderRadius: "0 0 0.3rem 0.3rem",
      boxShadow: `0 0 0 3px ${vars.colors.plBlue} inset`,
      pointerEvents: "none",
      animation: `${shadowFadeOut} 500ms ease-in forwards`,
      content: '""',
    },
  },
});

export const ownershipDirectionWrapper = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: vars.space["2xs"],
});

export const ownershipIconWrapper = style({
  display: "inline-flex",
  alignItems: "center",
  width: 12,
  height: 12,
});
